// extracted by mini-css-extract-plugin
module.exports =  {"tc-icon-text":"CellIconText-module__tc-icon-text___Wfla1","label":"CellIconText-module__label___wzhei"};